var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 9,
    height: 9,
    rx: 2,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5.5,
    width: 8,
    height: 8,
    rx: 1.5,
    stroke: "currentColor",
    strokeOpacity: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 3h6a.5.5 0 01.5.5V4h1v-.5A1.5 1.5 0 009.5 2h-6A1.5 1.5 0 002 3.5v6A1.5 1.5 0 003.5 11H4v-1h-.5a.5.5 0 01-.5-.5v-6a.5.5 0 01.5-.5z",
    fill: "currentColor"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIKICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxnIGlkPSIxNiAvIENvcHkiPgogICAgPGcgaWQ9IlN1cmZhY2UiPgogICAgICA8cmVjdCB4PSI1IiB5PSI1IiB3aWR0aD0iOSIgaGVpZ2h0PSI5IiByeD0iMiIgZmlsbD0iY3VycmVudENvbG9yIi8+CiAgICAgIDxyZWN0IHg9IjUuNSIgeT0iNS41IiB3aWR0aD0iOCIgaGVpZ2h0PSI4IiByeD0iMS41IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLW9wYWNpdHk9IjAuOSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CiAgICA8L2c+CiAgICA8cGF0aCBpZD0iU3VyZmFjZV8yIiBvcGFjaXR5PSIwLjc1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMuNTAwMDMgMy4wMDA0NEw5LjQ5OTk2IDMuMDAwMTJDOS43NzYyNSAzLjAwMDExIDkuOTk5OTkgMy4yMjM5IDkuOTk5OTkgMy40OTk5MlY0LjAwMDA3SDExVjMuNDk5OTJDMTEgMi42NzEzNCAxMC4zMjgyIDIuMDAwMDggOS40OTk5MSAyLjAwMDEyTDMuNDk5OTggMi4wMDA0NEMyLjY3MTU5IDIuMDAwNDkgMi4wMDAwNyAyLjY3MjA0IDIuMDAwMDYgMy41MDA0M0wyIDkuNTAwMDVDMS45OTk5OSAxMC4zMjg1IDIuNjcxNTcgMTEuMDAwMSAzLjUgMTEuMDAwMUgzLjk5OTk5VjEwLjAwMDFIMy41QzMuMjIzODYgMTAuMDAwMSAzIDkuNzc2MjEgMyA5LjUwMDA2TDMuMDAwMDYgMy41MDA0NEMzLjAwMDA2IDMuMjI0MzEgMy4yMjM5IDMuMDAwNDYgMy41MDAwMyAzLjAwMDQ0WiIgZmlsbD0iY3VycmVudENvbG9yIi8+CiAgPC9nPgo8L3N2Zz4K";
export { SvgCopy as ReactComponent };